module.exports = function() {
  return new Worker(__webpack_public_path__ + "d14aad9ad12d418de5be.worker.js");
};